// API service for reward and discount calculations
import axios from "axios";
import { API_CONFIG } from "../config/api.config";

const API_BASE_URL = API_CONFIG.BASE_URL;

const rewardApi = {
  // Calculate room booking discount
  calculateRoomDiscount: async (userId, amount) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/calculate-room-discount`,
        {
          userId: userId,
          amount: amount,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error calculating room discount:", error);
      throw error;
    }
  },

  // Calculate restaurant booking discount
  calculateRestaurantDiscount: async (userId, amount) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/calculate-restaurant-discount`,
        {
          userId: userId,
          amount: amount,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error calculating restaurant discount:", error);
      throw error;
    }
  },

  // Get user's current reward points
  getUserRewardPoints: async (userId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/profile/reward-points/${userId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching reward points:", error);
      throw error;
    }
  },
};

export default rewardApi;
